export class ProductImport {
  constructor(
    public id: string = '',
    public ok: number = 0,
    public errors: number = 0,
    public completed: boolean = false,
    public failed: boolean = false
  ) {}
}
